import { type FC } from 'react';
import classnames from 'classnames';

import { Spinner } from 'dibs-elements/exports/Spinner.tsx';
import dibsCss from 'dibs-css';
import overlayStyles from './OverlaySpinnerAdditional.module.css';

export const Loader: FC<{ fullHeight?: boolean }> = ({ fullHeight = false }) => (
    <div className={classnames(overlayStyles.container, { [dibsCss.h600px]: fullHeight })}>
        <Spinner />
    </div>
);
